import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './user.service';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class WalletService {
  loggedData: any = {};
  baseUrl: any = environment.apiUrl + 'wallet/';
  isChange = false;

  // tslint:disable-next-line: no-output-native
  @Output() change: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private userService: UserService
  ) {
    const data = this.cookieService.get(environment.authName);
    try {
      this.loggedData = data ? JSON.parse(data) : {};
    } catch (e) {
      this.cookieService.delete(environment.authName);
      this.loggedData = {};
    }
  }
  changeVerificationStatus() {
    this.isChange = !this.isChange;
    this.change.emit(this.isChange);
  }
  getDashboardDetailAllWallet() {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage);
    return this.http.get(this.baseUrl + 'get-dashboard-detail-all-wallet?preferredCurrency=' + loggedData?.preferredCurrency?.shortName || 'USD', { headers });

  }
  // getWalletInfo(token) {
  //   const loggedData = this.userService.getLoggedData();
  //   const tokenData = this.userService.getToken();

  //   const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
  //   return this.http.get(this.baseUrl + 'get-wallet-info?preferredCurrency=' + loggedData.preferredCurrency.shortName, { headers });

  // }
  getWhiteListAddresses(token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-whitelist-addresses', { headers });

  }
  updateBalance(token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'update-balance', { headers });

  }
  addWhiteListAddresses(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'whitelist-address', data, { headers });

  }
  deleteWhitelistedAddress(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'delete-whitelisted-address', data, { headers });

  }
  getWhiteListStatus(token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-whitelisting-status', { headers });

  }
  getWithdrawalHistory(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'get-withdrawal-history', data, { headers });

  }
  updateWhiteListingStatus(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-whitelisting-status', data, { headers });

  }
  getCurrencies(token = '') {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(this.baseUrl + 'get-currency-list', { headers });
  }
  getNewCurrencies(token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-balance-usd', { headers });

  }
  getDeposits(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'deposits', data, { headers });

  }

  generateWalletAddress(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'generate-address?coinShortName=' + data.coinShortName, { headers });

  }
  getTransectionFee(coinId, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-transaction-fee?coin=' + coinId, { headers });

  }
  getWithdrawalLimit(coinId, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-withdrawal-limit?coinShortName=' + coinId, { headers });

  }
  getWithdrawalRequest(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'generate-withdraw-request', data, { headers });

  }
  getWithdrawalRequestStatus(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'check-withdraw-status', { referenceNumber: data }, { headers });

  }
  getDashboardDetail(prefferedCurrency, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-dashboard-detail-all-wallet?preferredCurrency=' + prefferedCurrency, { headers });

  }
  getBalances() {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-balances', { headers });

  }
  getBalance(coin) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-balance?coinShortName=' + coin, { headers });

  }
  getCoinList() {
    const loggedData = this.userService.getLoggedData();
    if (!environment.production) {
      // console.log(loggedData);
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-coin-list', { headers });
  }
  getCoinListLanding() {
    const loggedData = this.userService.getLoggedData();
    if (!environment.production) {
      // console.log(loggedData);
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-coin-list-landing', { headers });
  }
  getCoinPriceAndCurrencyValue(coin, token) {
    const loggedData = this.userService.getLoggedData();

    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-coin-price-and-currency-value?coin=' + coin, { headers });

  }
  getCoinPrice(coin) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();

    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Authorization', 'Bearer ' + tokenData.token).set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-price?coinShortName=' + coin, { headers });

  }
}
